import {Component, OnInit} from "@angular/core";
import {DialogService} from "../../bootstrap-modal/dialog.service";
import {DialogComponent} from "../../bootstrap-modal/dialog.component";
import {FormGroup} from "@angular/forms";
import {Observable} from "rxjs";
import {AssetService} from "../../asset/asset.service";
import {SiteWorkflowService} from "./site-workflow.service";
import {
  AddAssetsDialogInputModel,
  addAssetsModelFactory,
  addAssetsStandaloneFormGroup,
  addAssetsWithDeviceFormGroup,
} from "./add-assets-dialog.model";
import {BulkOrderCountModel} from "./bulk-order-count.model";

@Component({
  templateUrl: "./add-assets-dialog.template.pug",
  providers: [
    AssetService,
    SiteWorkflowService,
  ],
})
export class AddAssetDialogComponent
  extends DialogComponent<AddAssetsDialogInputModel, number>
  implements AddAssetsDialogInputModel, OnInit {
  deviceId: string;
  siteId: string;
  maxQuantity: number;
  products: any[] = [];
  bulkOrderCounts: BulkOrderCountModel[] = [];
  maxQuantityPerDevice: number;
  maxQuantityPerBulkOrder: number;

  error: Error;
  assetsDialogForm: FormGroup;

  static showAssetModal(
    dialogService: DialogService,
    model: AddAssetsDialogInputModel,
  ): Observable<number> {
    return dialogService.addDialog(AddAssetDialogComponent, model, {backdropColor: "rgba(0, 0, 0, 0.5)"});
  }

  submit() {
    const {familyModel, ...fields} = this.assetsDialogForm.value;

    const params = addAssetsModelFactory({
      ...fields,
      deviceId: this.deviceId,
      siteId: this.siteId,
    });
    if (familyModel) {
      params.product = familyModel.productId;
      params.family = familyModel.familyName;
      params.model = familyModel.modelName;
      params.manufacturer = familyModel.manufacturer;
    }

    if (fields.bulkOrderNumber && fields.bulkOrderNumber.orderNumber && fields.bulkOrderNumber.orderDate) {
      params.orderNumber = fields.bulkOrderNumber.orderNumber;
      params.orderDate = fields.bulkOrderNumber.orderDate;
    }

    return this.assetService.batchCreate(params)
      .then(
        () => {
          this.result = 0;
          this.close();
        },
        (error) => {
          this.error = error;
        },
      );
  }

  async loadData() {
    this.error = undefined;
    if (this.deviceId) {
      this.products = await this.siteWorkflowService.getProducts(this.deviceId);
      this.products = this.products.sort((a, b) => a.productId - b.productId).reverse();
      this.assetsDialogForm.patchValue({...addAssetsModelFactory(), familyModel: this.products[0]});
    }
  }

  minWithNull(numberArray) {
    return numberArray.reduce((acc, n) => (typeof n === "number" ? Math.min(n, acc) : acc), Number.MAX_SAFE_INTEGER);
  }

  public changeBulkOrder() {
    if (this.assetsDialogForm) {
      const form = this.assetsDialogForm.getRawValue();
      if (form.bulkOrderNumber && typeof form.bulkOrderNumber.available === "number") {
        this.maxQuantityPerBulkOrder = form.bulkOrderNumber.available;
      } else this.maxQuantityPerBulkOrder = null;
      this.maxQuantity = this.minWithNull([this.maxQuantityPerDevice, this.maxQuantityPerBulkOrder]);
      if (form.quantity > this.maxQuantity) this.assetsDialogForm.controls["quantity"].setValue(this.maxQuantity);
    } else this.maxQuantityPerBulkOrder = null;
  }

  ngOnInit() {
    if (this.deviceId) {
      this.assetsDialogForm = addAssetsWithDeviceFormGroup(this.maxQuantity);
    } else {
      this.assetsDialogForm = addAssetsStandaloneFormGroup(this.maxQuantity);
    }
    this.maxQuantityPerDevice = this.maxQuantity;
    this.changeBulkOrder();

    this.loadData();
  }

  public eotLeaseDateChanged(): void {
    const date = this.assetsDialogForm.getRawValue().eotLeaseDatePicker;
    this.assetsDialogForm.controls["eotLeaseDate"].setValue(date);
  }

  constructor(
    public dialogService: DialogService,
    public assetService: AssetService,
    public siteWorkflowService: SiteWorkflowService,
  ) {
    super(dialogService);
  }
}
